var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-video"},[_c('div',{staticClass:"video-view",style:({ backgroundImage: _vm.bgImg })},[_c('video',{staticStyle:{"width":"100%","height":"100%","object-fit":"fill"},attrs:{"src":_vm.src,"controls":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }